export enum ForwardStatusEnum {
    PENDING   = 'Pending',
    FORWARDED = 'Forwarded',
    APPROVED  = 'Approved',
    REJECTED  = 'Rejected'

}
